var generateStyle = function generateStyle(componentTheme) {
  return {
    iconWrapper: {
      paddingRight: '0.25rem'
    },
    textWrapper: {
      width: '10rem'
    },
    stimulusDivider: {
      borderTop: "".concat(componentTheme.stimulusDividerBorderWidth, " solid ").concat(componentTheme.stimulusDividerBorderColor),
      marginTop: componentTheme.stimulusDividerMarginTop,
      marginBottom: componentTheme.stimulusDividerMarginBottom
    }
  };
};
export default generateStyle;